<template>
  <div>
    <v-row>
      <v-col cols="12">
        <h3>{{ stepHeader }}</h3>
        <p class="display-24" v-if="!isUserLogged">
          {{
            getString(stepContent, 'CVWizard_FirstStep_AlredySignedUp').Value
          }}
          <span class="pointer-underline" @click="showLogin">
            {{ getString(stepContent, 'CVWizard_FirstStep_Connect').Value }}
          </span>
        </p>
      </v-col>

      <v-col cols="12">
        <v-alert color="#f6f7f9">
          <strong
            class="d-block"
            v-html="getString(stepContent, 'CVWizard_ImportentTips').Value"
          ></strong>
          <span
            v-html="
              getString(stepContent, 'CVWizard_FirstStep_ImportentTipsText')
                .Value
            "
          ></span>
        </v-alert>
      </v-col>
    </v-row>
    <!-- /** valid sign up {{ modelSignUp }} */ -->
    <div v-if="isUserLogged">
      <UserPersonalDetails />
      <v-divider></v-divider>
      <UserPersonalDetailsEdit />
    </div>

    <div>
      <v-row v-if="userCvNumber == 4">
        <v-col cols="12" sm="6">
          <p class="display-16 my-2 red--text">
            לא ניתן להעלות קובץ נוסף, להחלפת קובץ לחצו
          </p>
          <SelectCv
            :fieldLabel="'בחר קוח'"
            :fieldIconName="'mdi-file-document '"
            :selectItems="getUserCvFiles"
            @child-field="applyCvName"
          />
          <p class="display-16 mt-1 red--text">
            שימו לב: החלפת הקובץ תגרום למחיקתו מכל המשרות אליהן נשלח בעבר.
          </p>
        </v-col>
      </v-row>
    </div>

    <div v-if="!isUserLogged">
      <v-form ref="formSigniIn" v-model="modelSignUp" class="rtl pa-0 mt-2">
        <v-row>
          <v-col cols="12" sm="6" class="py-0">
            <TextField
              :fieldLabel="
                getString(
                  stepContent,
                  'CVWizard_FirstStep_FirstNamePlaceHolder'
                ).Value
              "
              :fieldIconName="'mdi-account'"
              @child-field="applyName"
              v-model="FirstName"
            />
          </v-col>
          <v-col cols="12" sm="6" class="py-0">
            <TextField
              :fieldLabel="
                getString(stepContent, 'CVWizard_FirstStep_LastNamePlaceHolder')
                  .Value
              "
              :fieldIconName="'mdi-account'"
              @child-field="applyLastName"
              v-model="LastName"
            />
          </v-col>
          <v-col cols="12" sm="6" class="py-0">
            <PhoneNumberField @updateNumber="applyPhone" :showError="false" />
          </v-col>
          <v-col cols="12" sm="6" class="pb-7 pt-0 py-sm-0">
            <client-only>
              <LocationFieldNew @updateLocation="applyAddress" />
            </client-only>
          </v-col>
          <v-col cols="12" sm="6" class="py-0">
            <EmailField
              :editable="true"
              @newEmail="applyEmail"
              @copy.prevent
              @input="emailValidationNew = ''"
              @cut.prevent
              :newToCheck="true"
              :current-mail="
                getString(stepContent, 'CVWizard_FirstStep_EmailPlaceHolder')
                  .Value
              "
            />
          </v-col>
          <v-col cols="12" sm="6" class="py-0">
            <v-text-field
              v-model="emailValidationNew"
              outlined
              rounded
              solo
              :rules="emailValidationRules"
              type="text"
              label="הקלד שנית לצורך אימות"
              prepend-inner-icon="mdi-email-outline"
              class="text-field-input"
              ref="emailValidationField"
              required
              @paste.prevent
              autocomplete="new-email"
              dense
              dir="auto"
              :disabled="!isEmailValid"
            />
          </v-col>
          <v-col cols="12" sm="6" class="py-0">
            <PasswordField
              @newPassword="applyPassword"
              :showRecoverLink="false"
            />
          </v-col>
        </v-row>
      </v-form>
    </div>
    <div>
      <!-- /** valid SmartAgent - {{ validateSmartAgent }} */ -->
      <v-form
        ref="formSignSA"
        v-model="modelSignSmart"
        class="rtl pa-0 mt-2"
        lazy-validation
      >
        <v-row>
          <p
            class="display-22 mt-4 pr-4"
            v-html="
              getString(
                stepContent,
                'CVWizard_FirstStep_WhatWouldYouLikeToWork'
              ).Value
            "
          ></p>

          <v-col cols="12">
            <v-row>
              <v-col cols="12" md="6">
                <p class="display-22 font-weight-medium mb-2 mt-2 pr-md-0 pr-2">
                  בחירת תפקיד
                  <span class="primary--text">*</span>
                </p>
                <WhatField
                  placeholder="חפש תפקיד"
                  @whatSearch="updateWhatField"
                  @deleteWhat="deleteWhatJD"
                />
              </v-col>

              <v-col cols="12" md="6">
                <p class="display-22 font-weight-medium mb-2 mt-2 pr-md-0 pr-2">
                  איפה העבודה הבאה שלך?
                  <span class="primary--text">*</span>
                </p>
                <LocationWithRange
                  :isRounded="true"
                  class="primary--text"
                  :placeholder="'מיקום'"
                  @distanceSelected="updateDistanceSelectionA"
                  @updateLocation="updateSuggestedLocationA"
                  @deleteLocation="deleteLocationA"
                  @resetBtn="resetBtn = true"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-form>
    </div>
    <v-row>
      <v-col>
        <TermsField
          @newTerms="applyTerms"
          v-model="AgreeToTerms"
          v-show="!this.$auth.loggedIn"
        />
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col class="text-center my-3">
        <v-btn
          v-show="!isUserLogged"
          :loading="inProgress"
          color="primary"
          :disabled="!validateAll"
          @click="submitFirtsStep"
          rounded
          min-width="120"
        >
          {{ getString(stepContent, 'CVWizard_ContinueButton').Value }}
        </v-btn>
        <v-btn
          id="isUserLogged"
          v-show="isUserLogged"
          :loading="inProgress"
          color="primary"
          @click="submitFirtsStep"
          rounded
          min-width="120"
          :disabled="!validateSmartAgent || resetBtn"
        >
          {{ getString(stepContent, 'CVWizard_ContinueButton').Value }}
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { isEmpty, isNil, find } from 'lodash';
import CvStepsBase from '../base/CvStepsBase.vue';
import gtm from '@/lib/gtm';

import { t } from '@/store/modules/homeDrushim/constantsContent';

import LocationWithRange from '@/components/Forms/Form_Fields/LocationWithRange.vue';
import WhatField from '@/components/Forms/Form_Fields/WhatField.vue';
import { SIGN_UP, REGISTER_SMART_ALERTS } from '@/lib/api.js';
// import recaptchaV3 from '@/components/mixins/recaptchaV3';

export default {
  extends: CvStepsBase,
  // mixins: [recaptchaV3],
  components: { LocationWithRange, WhatField },
  computed: {
    isEmailValid() {
      return /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(this.Email);
    },

    /**
     * all forms
     * @param this.validateSmartAgent
     * @param this.modelSignUp
     * @param this.AgreeToTerms
     */
    validateAll() {
      return (
        this.validateSmartAgent && this.modelSignUp && this.AgreeToTerms // &&
        // this.validateWhere()
      );
    },

    /**
     * validate modelSignSmart Smart Agent alerts by fileds || if user allreadey registered isRegisteredSmartAlerts
     * @param this.selectedFirstSubCats
     * @param this.selectedFirstCat
     * @param this.regions
     * @param this.isRegisteredSmartAlerts
     */
    validateSmartAgent() {
      return find(
        [
          // !isEmpty(this.selectedFirstSubCats) &&
          //   !isEmpty(this.selectedFirstCat),
          // !isNil(this.isRegisteredSmartAlerts),
          !isEmpty(this.autoSuggestModelA) && !isEmpty(this.whatSearchJD),
        ],
        function (el) {
          return el === true;
        }
      );
    },
  },

  data() {
    return {
      // modelSignUp - sign up model form
      modelSignUp: false,
      FirstName: '',
      resetBtn: true,
      LastName: '',
      AgreeToTerms: false,
      Phone: '',
      CityId: null,
      Email: '',
      emailValidationNew: '',
      Password: '',
      RememberMe: true,

      // modelSignSmart - smartalert model form

      modelSignSmart: false,
      selectedFirstCat: [],
      selectedFirstSubCats: null,
      selectedSecondCat: null,
      selectedSecondSubCats: null,
      whatSearchJD: '',
      IsNew: false,
      CvCode: null,
      SaveParam: false,

      inProgress: false,
      currentStep: 'firststepLoggedOut',
      nextStep: 'secondstep',
      emailValidationRules: [(v) => !!v && this.checkEmailValidation()],

      wizardStep: 1,
      autoSuggestModelA: null,
      distanceModelA: { Code: 3, NameInHebrew: '30 ק"מ' }, // DEFAULT_DISTANCE,
      autoSuggestModelB: null,
      distanceModelB: { Code: 3, NameInHebrew: '30 ק"מ' }, // DEFAULT_DISTANCE,
      seccondAddress: false,
    };
  },

  mounted() {
    const currentStepNumber = this.$router.currentRoute.params.id;

    if (currentStepNumber == this.wizardStep) {
      if (this.isAvailable) {
        let payload = { stepname: this.currentStep, data: null };

        this.$store.dispatch('updateStepperStatus', payload).then(() => {
          this.init();
        });
      }
    }
  },

  methods: {
    checkEmailValidation() {
      if (this.emailValidationNew.localeCompare(this.Email)) {
        return t('titles.errorMessages.emailValidationFailed');
      } else {
        return true;
      }
    },
    showLogin() {
      document.querySelector('.login-btn').click();
    },
    init() {
      this.$nextTick(() => {
        /**
         * check if user Register to smart alerts
         * @getter getUserStatus
         * update form status - modelSignSmart
         */

        /**
         * update modelSignUp model
         */
        this.isUserLogged ? (this.modelSignUp = true) : false;
        /**
         * update AgreeToTerms model
         */
        this.isUserLogged && this.isRegisteredSmartAlerts
          ? (this.AgreeToTerms = true)
          : (this.AgreeToTerms = false);

        // Get Current cv code
        this.CvCode = this.getCurrentCVCode;
        // this.validate();
        this.validateSA();
      });
    },
    validate() {
      this.$refs.formSigniIn?.validate();
    },
    validateSA() {
      this.$refs.formSignSA?.validate();
    },
    resetForms() {
      this.$refs.formSigniIn.reset();
      this.$refs.formSignSA.reset();
    },

    applyCvName(val) {
      this.CvCode = val;
    },
    applyName(val) {
      this.FirstName = val;
    },
    applyLastName(val) {
      this.LastName = val;
    },

    applyEmail(val) {
      this.Email = val;
    },
    applyPhone(val) {
      this.Phone = val;
    },
    applyPassword(val) {
      this.Password = val;
    },

    applyTerms(val) {
      this.AgreeToTerms = val;
    },
    applyAddress(address) {
      this.CityId = address ? address.Code : null;
    },
    // handleSelectedCatDisplay(selectedCategory) {
    //   this.selectedFirstCat = selectedCategory;
    // },
    // handleSelectedSubCats(subCategoriesArr) {
    //   this.selectedFirstSubCats = subCategoriesArr;
    // },

    /**locations */
    updateDistanceSelectionA(value) {
      this.distanceModelA = value;
    },

    updateSuggestedLocationA(value) {
      this.resetBtn = false;
      this.autoSuggestModelA = value;
    },

    deleteLocationA() {
      this.autoSuggestModelA = null;
    },

    updateDistanceSelectionB(value) {
      this.distanceModelB = value;
    },

    updateSuggestedLocationB(value) {
      this.autoSuggestModelB = value;
    },

    handleDeletePrevLocationB() {
      this.autoSuggestModelB = null;
    },

    deleteLocationB() {
      this.autoSuggestModelB = null;
    },

    updateWhatField(value) {
      this.whatSearchJD = value;
    },

    deleteWhatJD() {
      this.whatSearchJD = '';
    },

    validateWhere() {
      if (
        this.autoSuggestModelA &&
        this.autoSuggestModelA.NameInHebrew &&
        this.autoSuggestModelA.GeoLexId
      ) {
        return true;
      } else {
        this.autoSuggestModelA = null;
        return false;
      }
    },
    /**locations */

    async submitFirtsStep() {
      /**
       * SIGNUP post data
       */
      const dataSignUP = {
        FirstName: this.FirstName,
        LastName: this.LastName,
        AgreeToTerms: this.AgreeToTerms,
        Email: this.Email,
        Password: this.Password,
        RememberMe: this.RememberMe,
        CityId: this.CityId ? this.CityId : 1201,
        Phone: this.Phone,
        Source: '3',
        FullSignUp: true,
      };

      this.inProgress = true;
      try {
        // const recaptcha = await this.recaptchaCheck('cvwizard');
        // if (!recaptcha) {
        //   throw 'ERROR => recaptcha';
        // }
        // SIGN_UP
        if (!this.isUserLogged) {
          await this.$axios.post(SIGN_UP, dataSignUP).then((response) => {
            if (response.data.IsError) {
              throw 'כתובת דוא"ל לא תקינה';
            }

            this.IsNew = true;

            gtm({
              event: 'real_user',
              page: 'user_s=real_new',
            });
            gtm({
              ID: response.data.RegistrationSource.RegistrationIdentifier,
              registration: response.data.RegistrationSource.Source,
              event: 'leadcrmregistration',
            });

            gtm({
              email: this.Email,
              phone: this.Phone,
              event: 'cv_wizard_gads',
            });
          });

          //  login
          await this.$auth
            .loginWith('local', {
              data: {
                email: this.Email,
                password: this.Password,
              },
            })
            .then(() => {
              this.currentStep = 'firststepLoggedIn';
              let payload = { stepname: this.currentStep, data: null };
              this.$store.dispatch('updateStepperStatus', payload);
            });
        }

        // if (!this.isRegisteredSmartAlerts) {
        let locationA = this.autoSuggestModelA?.GeoLexId;
        let distanceA = this.distanceModelA.Code;
        let locationB = this.autoSuggestModelB?.GeoLexId;
        let distanceB = this.distanceModelB?.Code;

        let Locations = locationA
          ? {
              [locationA]: distanceA,
              ...(locationB && { [locationB]: distanceB }),
            }
          : {};

        // let Categories = this.selectedFirstCat
        //   ? {
        //       ...(this.selectedFirstCat && {
        //         [this.selectedFirstCat?.Code]: this.selectedFirstSubCats,
        //       }),
        //     }
        //   : {};
        let Categories = {};

        let Keywords = this.whatSearchJD ? [this.whatSearchJD] : [];

        const dataSmartAlerts = {
          Categories,
          Locations,
          Keywords,
        };
        /**
         * REGISTER smart A.  post data
         */

        await this.$axios
          .post(REGISTER_SMART_ALERTS, dataSmartAlerts)
          .then((res) => {
            if (res.Error) {
              throw 'שגיאה';
            }
            this.inProgress = false;
          });
        // }

        await this.$auth.fetchUser();
        await this.submit();
      } catch (error) {
        console.log(error);
        this.$toast.error(error);
        this.inProgress = false;
      }
    },
    async submit() {
      let postdata = {
        HideBirthYear: true,
        HomePhone: '',
        Citizenship: '',
        IdNumber: '',
        FamilyStatus: '',
        Children: '',

        IsNew: this.IsNew,
        CvCode: this.CvCode,
        Save: true,
      };

      let payload = {
        stepname: this.nextStep,
        data: postdata,
      };

      gtm({
        email: this.Email,
        phone: this.Phone,
        event: 'cv_wizard_gads',
      });
      await this.$store.dispatch('updateStepperStatus', payload).then(() => {
        this.$router.push('/קורות-חיים/2/');
      });
    },
  },
  watch: {
    /* Clear autoSuggestModelB on hide seccondAddress */
    seccondAddress() {
      this.$refs.geo2.model = null;
      this.handleDeletePrevLocationB();
    },
  },
};
</script>
